const O = "rgba(29, 85, 228, 1)", E = "rgba(31, 40, 99, 1)", R = "rgba(31, 31, 31, 1)", _ = "rgba(239,244,255, 1)", A = "rgba(123, 127, 143, 0.24)", I = "rgba(248,248,248, 1)", D = "rgba(19,29,90)", o = {
  PRIMARY_BLUE: O,
  SECONDARY_BLUE: E,
  FONT_COLOR: R,
  DIMMED_BLUESIH_BACKGROUND: _,
  DIMMED_GRAYISH_BACKGROUND: A,
  APPLICATION_BACKGROUND: I,
  SECONDARY_BLUEISH_FONT_COLOR: D
};
export {
  I as APPLICATION_BACKGROUND,
  _ as DIMMED_BLUESIH_BACKGROUND,
  A as DIMMED_GRAYISH_BACKGROUND,
  R as FONT_COLOR,
  o as KORPAERAET_EIDENTITI,
  O as PRIMARY_BLUE,
  E as SECONDARY_BLUE,
  D as SECONDARY_BLUEISH_FONT_COLOR
};
